module.exports = __webpack_public_path__ + "static/mike-970ffbbf26bfae5b817fd00418e4ed97.jpg";